<template>
  <section id="report-found-other">
    <h4 class="data-title font-h2">数据填报</h4>
    <div class="data-content">
      <div class="data-item" v-for="(user, index) in userList" :key="index">
        <p class="data-item__label font-labelheavy">{{ user.label }}</p>
        <edit-input-vue
          v-for="(info, index) in userInfoList"
          v-model="reportDetail[user.value[index]]"
          :key="index"
          :label="info"
          :edit="visibleEdit"
        />
      </div>
    </div>
    <div class="options">
      <div
        v-for="(option, index) in checkOptions"
        :key="index"
        class="options-item"
      >
        <!-- 每种选项的说明 -->
        <p class="options-item__label font-labelheavy">
          {{ option.label }}
          <span class="options-item__tip">
            （{{ option.type === 'radio' ? '单选' : '多选' }}）
          </span>
        </p>

        <!-- 选项 radio -->
        <el-radio-group
          v-model="reportDetail[option.value]"
          v-if="option.type === 'radio'"
          class="options-item__list flex-align"
          :disabled="!visibleEdit"
        >
          <el-radio
            v-for="(radio, index) in option.list"
            :key="index"
            :label="radio.value"
            class="options-item__radio flex-align"
          >
            {{ radio.label }}
          </el-radio>
        </el-radio-group>

        <!-- 选项 checkbox -->
        <el-checkbox-group
          v-model="reportDetail[option.value]"
          v-if="option.type === 'checkbox'"
          class="options-item__list flex-align"
          :disabled="!visibleEdit"
        >
          <el-checkbox
            v-for="(checkbox, index) in option.list"
            :key="index"
            :label="checkbox.value"
            class="options-item__checkbox flex-align"
          >
            {{ checkbox.label }}
            <el-input
              class="checkbox-input"
              v-if="checkbox.append"
              v-model="reportDetail[option.appendValue]"
            />
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </section>
</template>

<script>
import editInputVue from '../layout/edit-input.vue';
export default {
  name: 'ReportCreateOptions',
  components: {
    editInputVue
  },
  props: {
    reportDetail: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean
    }
  },
  data() {
    return {
      userList: [
        {
          label: '所有权人（单位）',
          value: ['owner', 'ownerContact']
        },
        {
          label: '使用人（单位）',
          value: ['user', 'userContact']
        },
        {
          label: '代理人（单位）',
          value: ['agent', 'agentContact']
        }
      ],
      userInfoList: ['姓名（名称）:', '联系方式:'],
      checkOptions: [
        {
          label: '管理者',
          type: 'radio',
          value: 'relicDirectorEnum',
          list: [
            {
              label: '个人',
              value: 'INDIVIDUAL'
            },
            {
              label: '建筑主管部门',
              value: 'GOVERNMENT'
            },
            {
              label: '所在镇、街道',
              value: 'LOCAL'
            },
            {
              label: '其他',
              value: 'OTHERS'
            }
          ]
        },
        {
          label: '是否已挂牌',
          type: 'radio',
          value: 'brandStatusEnum',
          list: [
            {
              label: '已挂牌',
              value: 'YIGUAPAI'
            },
            {
              label: '未挂牌',
              value: 'WEIGUAPAI'
            }
          ]
        },
        {
          label: '外立面改变',
          type: 'radio',
          value: 'facadeStatusEnum',
          list: [
            {
              label: '有',
              value: 'CHANGED'
            },
            {
              label: '无',
              value: 'UNCHANGED'
            }
          ]
        },
        {
          label: '建筑破损',
          type: 'radio',
          value: 'buildingDamageStatusEnum',
          list: [
            {
              label: '有',
              value: 'BROKEN'
            },
            {
              label: '无',
              value: 'NOT_BROKEN'
            }
          ]
        },
        {
          label: '正在施工',
          type: 'checkbox',
          value: 'constructingComponentEnums',
          appendValue: 'otherConstructingComponents',
          list: [
            {
              label: '院落',
              value: 'YARD'
            },
            {
              label: '门窗',
              value: 'DOORS_OR_WINDOWS'
            },
            {
              label: '室内',
              value: 'INTERIOR'
            },
            {
              label: '外墙',
              value: 'EXTERIOR_WALL'
            },
            {
              label: '结构主体',
              value: 'STRUCT_BODY'
            },
            {
              label: '其他',
              value: 'OTHERS',
              append: true
            }
          ]
        },
        {
          label: '其他情况',
          type: 'checkbox',
          value: 'otherSituationEnums',
          list: [
            {
              label: '无法入内',
              value: 'NO_ENTRY'
            },
            {
              label: '找不到门牌',
              value: 'HOUSE_NUMBER_NOT_FOUND'
            },
            {
              label: '地址勘误',
              value: 'AMEND_ADDRESS'
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss">
#report-found-other {
  margin-top: 15px;
  .data {
    &-title {
      color: $color-label;
      font-size: 15px;
      font-weight: 900;
      line-height: 25px;
    }
    &-content {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
    &-item {
      margin-top: 15px;
      &__label {
        line-height: 25px;
        height: 25px;
        color: $color-label;
      }
    }
  }
  .edit-input {
    &__label {
      min-width: 100px;
    }
    &__content {
      margin-left: 8px;
      width: 174px;
    }
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    &-item {
      flex: 50%;
      padding: 10px 0px;
      border-top: 1px solid $color-border-light;
      // &:not(:first-child) {
      //   margin-top: 25px;
      // }
      &__label {
        line-height: 25px;
        color: $color-label;
      }
      &__tip {
        color: $color-border-light;
      }
      &__list {
        margin-top: 12px;
        flex-wrap: wrap;
      }
      &__radio {
        margin-right: 0;
        width: 50%;
        margin-bottom: 15px;
      }
      &__checkbox {
        margin-right: 0;
        margin-bottom: 15px;
        width: 50%;
      }
    }
  }
  .el-radio {
    color: $color-info;
    &.is-checked {
      .el-radio {
        &__inner::after {
          opacity: 1;
        }
      }
    }
    &__inner {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12px;
      height: 12px;
      box-shadow: none;
      &::after {
        position: unset;
        opacity: 0;
        transform: unset;
      }
    }
  }
  .el-checkbox {
    &__inner {
      transition: unset;
      &::after {
        transition: unset;
      }
    }
    &__label {
      font-size: 13px;
      line-height: 15px;
      color: $color-info;
    }
  }
  .checkbox {
    &-input {
      .el-input {
        &__inner {
          padding: 0 2px;
          width: 60px;
          height: 15px;
          line-height: 15px;
          border-width: 0;
          border-bottom-width: 1px;
          border-radius: 0;
          border-color: #cccccc;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #report-found-other {
    .options {
      &-item {
        flex: 100%;
        &:not(:first-child) {
          margin-top: 27px;
        }
        &__radio {
          width: 50%;
          margin-bottom: 10px;
        }
        &__checkbox {
          width: 50%;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
